import React, { useState } from "react";
import { Send, RefreshCw } from "lucide-react";
import Avatar from "components/ui/Avatar";
import { getDisplayIdentity } from "utils/user-identity";

// Single-line-looking composer card — avatar and input share one row inside
// a soft shadowed card (no border), with the Post/Cancel footer appearing
// only once there's something typed, so an empty composer stays minimal.
const CommentComposer = ({ currentUser, placeholder = "Add a comment...", onSubmit, onCancel, submitLabel = "Post" }) => {
  const [text, setText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Show the identity the comment will actually be posted under — a
  // SUPER_ADMIN writes as Surya Group, so the composer shows the brand mark.
  const identity = getDisplayIdentity(currentUser);

  const handleSubmit = async () => {
    if (!text.trim() || submitting) return;
    setSubmitting(true);
    try {
      await onSubmit(text.trim());
      setText("");
      onCancel?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rounded-2xl bg-surface shadow-sm">
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="flex-shrink-0">
          <Avatar user={identity?.avatarUser} size={32} fit={identity?.isBrand ? "contain" : "cover"} />
        </div>
        <textarea
          rows={1}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
          className="flex-1 min-w-0 bg-transparent text-[13.5px] text-text_primary placeholder:text-text_muted outline-none resize-none py-1"
        />
      </div>

      {text.trim() && (
        <div className="flex items-center justify-end gap-2 px-4 pb-3">
          {onCancel && (
            <button type="button" onClick={onCancel} className="px-2.5 py-1 text-[11px] font-medium text-text_secondary">
              Cancel
            </button>
          )}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={submitting}
            className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[11.5px] font-semibold text-white bg-primary shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {submitting ? <RefreshCw size={11} className="animate-spin" /> : <Send size={11} />}
            {submitLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default CommentComposer;
